import type { SaveOrderSettingsPayload, SaveOrderSettingsResponse } from '@/api/models/OrderSettings';
import { postRequest } from '../clients/axios';

export const postSaveOrderSettings = async (payload: SaveOrderSettingsPayload): Promise<{ status: number; data: SaveOrderSettingsResponse | null }> => {
  const response = await postRequest<SaveOrderSettingsResponse | null>('appsetting/SaveOrderEntryAppUserSetting', payload);
  return { status: response.status, data: response.data };
};
